/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-setting-icon[_ngcontent-%COMP%]{position:absolute;top:0;left:19%;opacity:.07;font-size:630px!important;width:630px!important;height:630px!important}"];
export { styles as styles };
